export default __webpack_public_path__ + "static/media/game_fg_2x.34ef1b3d.png";